export default __webpack_public_path__ + "static/media/react.33b347f8.svg";